import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "nd" }
const _hoisted_2 = { class: "nd-toolbar" }
const _hoisted_3 = { class: "nd-toolbar__title" }
const _hoisted_4 = {
  key: 0,
  class: "nd-toolbar__range"
}
const _hoisted_5 = { class: "nd-toolbar__filters" }
const _hoisted_6 = { class: "nd-field" }
const _hoisted_7 = { class: "nd-field" }
const _hoisted_8 = { class: "nd-field" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "nd-field" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "nd-field" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "nd-field" }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "nd-field" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "nd-spin"
}
const _hoisted_19 = {
  key: 0,
  class: "nd-skeleton"
}
const _hoisted_20 = { class: "nd-kpis" }
const _hoisted_21 = { class: "nd-kpi__icon" }
const _hoisted_22 = { class: "nd-kpi__body" }
const _hoisted_23 = { class: "nd-kpi__label" }
const _hoisted_24 = { class: "nd-kpi__value" }
const _hoisted_25 = {
  key: 0,
  class: "nd-kpi__sub"
}
const _hoisted_26 = { class: "nd-owedwrap" }
const _hoisted_27 = {
  class: "nd-kpi nd-kpi--owed",
  style: { '--accent': '#f44336' }
}
const _hoisted_28 = { class: "nd-kpi__body" }
const _hoisted_29 = { class: "nd-kpi__value nd-kpi__value--xl" }
const _hoisted_30 = { class: "nd-grid nd-grid--2" }
const _hoisted_31 = { class: "nd-card" }
const _hoisted_32 = { class: "nd-table" }
const _hoisted_33 = { class: "nd-rank" }
const _hoisted_34 = { class: "nd-track" }
const _hoisted_35 = { class: "nd-amt nd-amt--danger" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "nd-card" }
const _hoisted_38 = { class: "nd-table" }
const _hoisted_39 = { class: "nd-rank" }
const _hoisted_40 = { class: "nd-track" }
const _hoisted_41 = { class: "nd-amt nd-amt--danger" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "nd-card nd-card--wide" }
const _hoisted_44 = {
  key: 0,
  class: "nd-chart"
}
const _hoisted_45 = { class: "nd-chart__stack" }
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]
const _hoisted_48 = { class: "nd-chart__label" }
const _hoisted_49 = {
  key: 1,
  class: "nd-empty"
}
const _hoisted_50 = {
  key: 2,
  class: "nd-pchart-head"
}
const _hoisted_51 = {
  key: 3,
  class: "nd-pchart"
}
const _hoisted_52 = ["title"]
const _hoisted_53 = { class: "nd-pchart__pos" }
const _hoisted_54 = { class: "nd-pchart__neg" }
const _hoisted_55 = { class: "nd-chart__label" }
const _hoisted_56 = { class: "nd-grid nd-grid--3" }
const _hoisted_57 = { class: "nd-card" }
const _hoisted_58 = { class: "nd-table" }
const _hoisted_59 = { class: "nd-track" }
const _hoisted_60 = { class: "nd-amt" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "nd-card" }
const _hoisted_63 = { class: "nd-table" }
const _hoisted_64 = { class: "nd-track" }
const _hoisted_65 = { class: "nd-amt nd-amt--profit" }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { class: "nd-card" }
const _hoisted_68 = { class: "nd-table" }
const _hoisted_69 = { class: "nd-track" }
const _hoisted_70 = { class: "nd-amt" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "nd-grid nd-grid--3" }
const _hoisted_73 = { class: "nd-card" }
const _hoisted_74 = { class: "nd-dual" }
const _hoisted_75 = { class: "nd-bignum" }
const _hoisted_76 = { class: "nd-bignum nd-bignum--warn" }
const _hoisted_77 = { class: "nd-table nd-table--tight" }
const _hoisted_78 = { class: "nd-amt nd-amt--warn" }
const _hoisted_79 = { class: "nd-card" }
const _hoisted_80 = { class: "nd-card__head" }
const _hoisted_81 = { class: "nd-badge nd-badge--danger" }
const _hoisted_82 = { class: "nd-pills nd-scroll" }
const _hoisted_83 = {
  key: 0,
  class: "nd-empty"
}
const _hoisted_84 = { class: "nd-card" }
const _hoisted_85 = { class: "nd-card__head" }
const _hoisted_86 = { class: "nd-toggle" }
const _hoisted_87 = { class: "nd-lowstock nd-scroll" }
const _hoisted_88 = {
  key: 0,
  class: "nd-empty"
}
const _hoisted_89 = { class: "nd-card nd-card--wide" }
const _hoisted_90 = { class: "nd-card__head" }
const _hoisted_91 = { class: "nd-invtools" }
const _hoisted_92 = { class: "nd-toggle" }
const _hoisted_93 = {
  key: 0,
  class: "nd-invchart"
}
const _hoisted_94 = ["onClick"]
const _hoisted_95 = { class: "nd-invrow__name" }
const _hoisted_96 = { class: "nd-invrow__bars" }
const _hoisted_97 = ["title"]
const _hoisted_98 = ["title"]
const _hoisted_99 = {
  key: 1,
  class: "nd-empty"
}
const _hoisted_100 = {
  key: 2,
  class: "nd-empty"
}
const _hoisted_101 = {
  key: 3,
  class: "nd-invdetail"
}
const _hoisted_102 = { class: "nd-invdetail__head" }
const _hoisted_103 = { class: "nd-invstats" }
const _hoisted_104 = { class: "nd-invstat" }
const _hoisted_105 = { class: "c-in-text" }
const _hoisted_106 = { class: "nd-invstat" }
const _hoisted_107 = { class: "c-out-text" }
const _hoisted_108 = { class: "nd-invstat" }
const _hoisted_109 = { class: "nd-grid nd-grid--2" }
const _hoisted_110 = { class: "nd-scroll" }
const _hoisted_111 = { class: "nd-table" }
const _hoisted_112 = { class: "nd-amt" }
const _hoisted_113 = { class: "nd-amt" }
const _hoisted_114 = { class: "nd-amt" }
const _hoisted_115 = { class: "nd-scroll" }
const _hoisted_116 = { class: "nd-table" }
const _hoisted_117 = { class: "nd-amt" }
const _hoisted_118 = { class: "nd-amt" }
const _hoisted_119 = { class: "nd-amt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "mb-0" }, "Dashboard", -1)),
        (_ctx.data)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.shortDate(_ctx.filters.from)) + " — " + _toDisplayString(_ctx.shortDate(_ctx.filters.to)), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("label", null, "From", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.from) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filters.from]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[16] || (_cache[16] = _createElementVNode("label", null, "To", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.to) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filters.to]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[18] || (_cache[18] = _createElementVNode("label", null, "Company", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.company_id) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onCompanyChange && _ctx.onCompanyChange(...args)))
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("option", { value: "" }, "All companies", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.companies, (c) => {
              return (_openBlock(), _createElementBlock("option", {
                key: c.id,
                value: c.id
              }, _toDisplayString(c.name), 9, _hoisted_9))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.filters.company_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[20] || (_cache[20] = _createElementVNode("label", null, "Salesman", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.salesman_id) = $event))
          }, [
            _cache[19] || (_cache[19] = _createElementVNode("option", { value: "" }, "All salesmen", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.salesmen, (s) => {
              return (_openBlock(), _createElementBlock("option", {
                key: s.id,
                value: s.id
              }, _toDisplayString(s.name), 9, _hoisted_11))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.filters.salesman_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[22] || (_cache[22] = _createElementVNode("label", null, "Shop", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.shop_id) = $event))
          }, [
            _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "All shops", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shops, (sh) => {
              return (_openBlock(), _createElementBlock("option", {
                key: sh.id,
                value: sh.id
              }, _toDisplayString(sh.name), 9, _hoisted_13))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.filters.shop_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[24] || (_cache[24] = _createElementVNode("label", null, "Product", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.product_id) = $event))
          }, [
            _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "All products", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (p) => {
              return (_openBlock(), _createElementBlock("option", {
                key: p.id,
                value: p.id
              }, _toDisplayString(p.name), 9, _hoisted_15))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.filters.product_id]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[25] || (_cache[25] = _createElementVNode("label", null, "Low stock ≤", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.low_stock_threshold) = $event))
          }, null, 512), [
            [
              _vModelText,
              _ctx.filters.low_stock_threshold,
              void 0,
              { number: true }
            ]
          ])
        ]),
        _createElementVNode("button", {
          class: "nd-apply",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args))),
          disabled: _ctx.loading
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Loading' : 'Apply'), 1)
        ], 8, _hoisted_17)
      ])
    ]),
    (_ctx.loading && !_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
            return _createElementVNode("div", {
              class: "nd-skeleton__card",
              key: n
            })
          }), 64))
        ]))
      : _createCommentVNode("", true),
    (_ctx.data)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kpiCards, (k) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "nd-kpi",
                key: k.label,
                style: _normalizeStyle({ '--accent': k.color })
              }, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(k.icon), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("p", _hoisted_23, _toDisplayString(k.label), 1),
                  _createElementVNode("h4", _hoisted_24, _toDisplayString(k.value), 1),
                  (k.sub)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(k.sub), 1))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("section", _hoisted_27, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "nd-kpi__icon" }, "💵", -1)),
              _createElementVNode("div", _hoisted_28, [
                _cache[26] || (_cache[26] = _createElementVNode("p", { class: "nd-kpi__label" }, "Money owed to us", -1)),
                _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.money(_ctx.data.receivables.total)), 1),
                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "nd-kpi__sub" }, "Receivables · as of today", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("section", _hoisted_31, [
              _cache[30] || (_cache[30] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Top shops that owe most"),
                _createElementVNode("span", { class: "nd-badge" }, "Top 10")
              ], -1)),
              _createElementVNode("table", _hoisted_32, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.receivables.top_shops, (s, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: s.shop_id
                    }, [
                      _createElementVNode("td", _hoisted_33, _toDisplayString(Number(i) + 1), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: "/balancesheet/shop",
                          class: "nd-link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(s.shop_name), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("span", {
                            style: _normalizeStyle({ width: _ctx.pct(s.balance, _ctx.data.receivables.top_shops, 'balance') })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.money(s.balance)), 1)
                    ]))
                  }), 128)),
                  (!_ctx.data.receivables.top_shops.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [...(_cache[29] || (_cache[29] = [
                        _createElementVNode("td", {
                          colspan: "3",
                          class: "nd-empty"
                        }, "No outstanding balances.", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_37, [
              _cache[32] || (_cache[32] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Top salesmen owed most"),
                _createElementVNode("span", { class: "nd-badge" }, "Top 10")
              ], -1)),
              _createElementVNode("table", _hoisted_38, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.receivables.top_salesmen, (sm, i) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: sm.salesman_id
                    }, [
                      _createElementVNode("td", _hoisted_39, _toDisplayString(Number(i) + 1), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(sm.name) + " ", 1),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("span", {
                            class: "c-owed",
                            style: _normalizeStyle({ width: _ctx.pct(sm.balance, _ctx.data.receivables.top_salesmen, 'balance') })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.money(sm.balance)), 1)
                    ]))
                  }), 128)),
                  (!_ctx.data.receivables.top_salesmen.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("td", {
                          colspan: "3",
                          class: "nd-empty"
                        }, "No outstanding balances.", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_43, [
            _cache[34] || (_cache[34] = _createElementVNode("header", { class: "nd-card__head" }, [
              _createElementVNode("h6", null, "Daily sales & collected"),
              _createElementVNode("div", { class: "nd-legend" }, [
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "c-sales" }),
                  _createTextVNode("Sales")
                ]),
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "c-collected" }),
                  _createTextVNode("Collected")
                ])
              ])
            ], -1)),
            (_ctx.data.sales.daily.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.sales.daily, (d) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "nd-chart__col",
                      key: d.date
                    }, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", {
                          class: "nd-chart__bar c-sales",
                          style: _normalizeStyle(_ctx.barStyle(d.sales)),
                          title: 'Sales ' + _ctx.money(d.sales)
                        }, null, 12, _hoisted_46),
                        _createElementVNode("div", {
                          class: "nd-chart__bar c-collected",
                          style: _normalizeStyle(_ctx.barStyle(d.collected)),
                          title: 'Collected ' + _ctx.money(d.collected)
                        }, null, 12, _hoisted_47)
                      ]),
                      _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.shortDate(d.date)), 1)
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_49, "No sales in this range.")),
            (_ctx.data.sales.daily.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [...(_cache[33] || (_cache[33] = [
                  _createElementVNode("h6", null, "Daily profit", -1),
                  _createElementVNode("div", { class: "nd-legend" }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "c-profit" }),
                      _createTextVNode("Profit")
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("i", { class: "c-loss" }),
                      _createTextVNode("Loss")
                    ])
                  ], -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.data.sales.daily.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.sales.daily, (d) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "nd-pchart__col",
                      key: 'p' + d.date,
                      title: (d.profit < 0 ? 'Loss ' : 'Profit ') + _ctx.money(d.profit)
                    }, [
                      _createElementVNode("div", _hoisted_53, [
                        _createElementVNode("span", {
                          style: _normalizeStyle(_ctx.posBar(d.profit))
                        }, null, 4)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createElementVNode("span", {
                          style: _normalizeStyle(_ctx.negBar(d.profit))
                        }, null, 4)
                      ]),
                      _createElementVNode("p", _hoisted_55, _toDisplayString(_ctx.shortDate(d.date)), 1)
                    ], 8, _hoisted_52))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("section", _hoisted_57, [
              _cache[36] || (_cache[36] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Sales by salesman")
              ], -1)),
              _createElementVNode("table", _hoisted_58, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.sales.by_salesman, (s) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: s.salesman_id
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(s.name), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("span", {
                            class: "c-sales",
                            style: _normalizeStyle({ width: _ctx.pct(s.sales, _ctx.data.sales.by_salesman, 'sales') })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_60, _toDisplayString(_ctx.money(s.sales)), 1)
                    ]))
                  }), 128)),
                  (!_ctx.data.sales.by_salesman.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_61, [...(_cache[35] || (_cache[35] = [
                        _createElementVNode("td", {
                          colspan: "2",
                          class: "nd-empty"
                        }, "No data.", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_62, [
              _cache[38] || (_cache[38] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Top products by profit")
              ], -1)),
              _createElementVNode("table", _hoisted_63, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.sales.top_products, (p) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: p.product_id
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(p.name), 1),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("span", {
                            class: "c-profit",
                            style: _normalizeStyle({ width: _ctx.pct(p.profit, _ctx.data.sales.top_products, 'profit') })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_65, _toDisplayString(_ctx.money(p.profit)), 1)
                    ]))
                  }), 128)),
                  (!_ctx.data.sales.top_products.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_66, [...(_cache[37] || (_cache[37] = [
                        _createElementVNode("td", {
                          colspan: "2",
                          class: "nd-empty"
                        }, "No data.", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_67, [
              _cache[40] || (_cache[40] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Sales by company")
              ], -1)),
              _createElementVNode("table", _hoisted_68, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.sales.by_company, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.company_id
                    }, [
                      _createElementVNode("td", null, [
                        _createTextVNode(_toDisplayString(c.name), 1),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("span", {
                            class: "c-collected",
                            style: _normalizeStyle({ width: _ctx.pct(c.sales, _ctx.data.sales.by_company, 'sales') })
                          }, null, 4)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.money(c.sales)), 1)
                    ]))
                  }), 128)),
                  (!_ctx.data.sales.by_company.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_71, [...(_cache[39] || (_cache[39] = [
                        _createElementVNode("td", {
                          colspan: "2",
                          class: "nd-empty"
                        }, "No data.", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_72, [
            _createElementVNode("section", _hoisted_73, [
              _cache[43] || (_cache[43] = _createElementVNode("header", { class: "nd-card__head" }, [
                _createElementVNode("h6", null, "Stock & payables"),
                _createElementVNode("span", { class: "nd-badge nd-badge--warn" }, "We owe")
              ], -1)),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", null, [
                  _cache[41] || (_cache[41] = _createElementVNode("p", { class: "nd-kpi__label" }, "Stock value on hand", -1)),
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.money(_ctx.data.stock.stock_value)), 1)
                ]),
                _createElementVNode("div", null, [
                  _cache[42] || (_cache[42] = _createElementVNode("p", { class: "nd-kpi__label" }, "Payables to companies", -1)),
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.money(_ctx.data.stock.payables_total)), 1)
                ])
              ]),
              _createElementVNode("table", _hoisted_77, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stock.payables, (c) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: c.company_id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(c.name), 1),
                      _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.money(c.balance)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("section", _hoisted_79, [
              _createElementVNode("header", _hoisted_80, [
                _cache[44] || (_cache[44] = _createElementVNode("h6", null, "Out of stock", -1)),
                _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.data.stock.out_of_stock.length), 1)
              ]),
              _createElementVNode("div", _hoisted_82, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stock.out_of_stock, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "nd-pill nd-pill--danger",
                    key: p.product_id
                  }, _toDisplayString(p.name), 1))
                }), 128)),
                (!_ctx.data.stock.out_of_stock.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_83, "Everything is in stock. 🎉"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("section", _hoisted_84, [
              _createElementVNode("header", _hoisted_85, [
                _cache[45] || (_cache[45] = _createElementVNode("h6", null, "Low stock", -1)),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("button", {
                    class: _normalizeClass({ on: _ctx.stockUnit === 'boxes' }),
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.stockUnit = 'boxes'))
                  }, "Boxes", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass({ on: _ctx.stockUnit === 'cartons' }),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.stockUnit = 'cartons'))
                  }, "Cartons", 2)
                ])
              ]),
              _createElementVNode("ul", _hoisted_87, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stock.low_stock, (p) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: p.product_id
                  }, [
                    _createElementVNode("span", null, _toDisplayString(p.name), 1),
                    _createElementVNode("b", null, _toDisplayString(_ctx.fmtStock(p.quantity, p.boxes_per_carton)), 1)
                  ]))
                }), 128)),
                (!_ctx.data.stock.low_stock.length)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_88, "No low-stock items."))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_89, [
            _createElementVNode("header", _hoisted_90, [
              _cache[47] || (_cache[47] = _createElementVNode("h6", null, "Inventory In / Out by company", -1)),
              _createElementVNode("div", _hoisted_91, [
                _cache[46] || (_cache[46] = _createElementVNode("div", { class: "nd-legend" }, [
                  _createElementVNode("span", null, [
                    _createElementVNode("i", { class: "c-in" }),
                    _createTextVNode("In")
                  ]),
                  _createElementVNode("span", null, [
                    _createElementVNode("i", { class: "c-out" }),
                    _createTextVNode("Out")
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("button", {
                    class: _normalizeClass({ on: _ctx.invUnit === 'boxes' }),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.invUnit = 'boxes'))
                  }, "Boxes", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass({ on: _ctx.invUnit === 'value' }),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.invUnit = 'value'))
                  }, "Value", 2)
                ])
              ])
            ]),
            _cache[56] || (_cache[56] = _createElementVNode("p", { class: "nd-hint" }, "Click a company to see its inventory detail.", -1)),
            (_ctx.inv.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inv, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["nd-invrow", { active: _ctx.invDetail && _ctx.invDetail.company_id === c.company_id }]),
                      key: c.company_id,
                      onClick: ($event: any) => (_ctx.openInvDetail(c.company_id))
                    }, [
                      _createElementVNode("div", _hoisted_95, _toDisplayString(c.name), 1),
                      _createElementVNode("div", _hoisted_96, [
                        _createElementVNode("div", {
                          class: "nd-invrow__bar",
                          title: 'In: ' + _ctx.invLabel(c, 'in')
                        }, [
                          _createElementVNode("span", {
                            class: "c-in",
                            style: _normalizeStyle({ width: _ctx.invW(_ctx.invMetric(c, 'in')) })
                          }, null, 4),
                          _createElementVNode("em", null, _toDisplayString(_ctx.invLabel(c, 'in')), 1)
                        ], 8, _hoisted_97),
                        _createElementVNode("div", {
                          class: "nd-invrow__bar",
                          title: 'Out: ' + _ctx.invLabel(c, 'out')
                        }, [
                          _createElementVNode("span", {
                            class: "c-out",
                            style: _normalizeStyle({ width: _ctx.invW(_ctx.invMetric(c, 'out')) })
                          }, null, 4),
                          _createElementVNode("em", null, _toDisplayString(_ctx.invLabel(c, 'out')), 1)
                        ], 8, _hoisted_98)
                      ])
                    ], 10, _hoisted_94))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_99, "No inventory movement in this range.")),
            (_ctx.invLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_100, "Loading detail…"))
              : (_ctx.invDetail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                    _createElementVNode("div", _hoisted_102, [
                      _createElementVNode("h6", null, _toDisplayString(_ctx.invDetail.name) + " — inventory detail", 1),
                      _createElementVNode("button", {
                        class: "nd-x",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.invDetail = null))
                      }, "✕")
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _createElementVNode("div", _hoisted_104, [
                        _cache[48] || (_cache[48] = _createElementVNode("span", null, "In", -1)),
                        _createElementVNode("b", _hoisted_105, _toDisplayString(_ctx.fmtQty2(_ctx.invDetail.totals.in_qty)) + " box", 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.money(_ctx.invDetail.totals.in_value)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_106, [
                        _cache[49] || (_cache[49] = _createElementVNode("span", null, "Out", -1)),
                        _createElementVNode("b", _hoisted_107, _toDisplayString(_ctx.fmtQty2(_ctx.invDetail.totals.out_qty)) + " box", 1),
                        _createElementVNode("small", null, _toDisplayString(_ctx.money(_ctx.invDetail.totals.out_value)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_108, [
                        _cache[50] || (_cache[50] = _createElementVNode("span", null, "Net moved", -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.fmtQty2(_ctx.invDetail.totals.net_qty)) + " box", 1),
                        _cache[51] || (_cache[51] = _createElementVNode("small", null, " ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_109, [
                      _createElementVNode("div", null, [
                        _cache[53] || (_cache[53] = _createElementVNode("h6", { class: "nd-subh" }, "By product", -1)),
                        _createElementVNode("div", _hoisted_110, [
                          _createElementVNode("table", _hoisted_111, [
                            _cache[52] || (_cache[52] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Product"),
                                _createElementVNode("th", { class: "nd-amt" }, "In"),
                                _createElementVNode("th", { class: "nd-amt" }, "Out"),
                                _createElementVNode("th", { class: "nd-amt" }, "In ₨")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invDetail.by_product, (p) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: p.product_id
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(p.name), 1),
                                  _createElementVNode("td", _hoisted_112, _toDisplayString(_ctx.fmtQty2(p.in_qty)), 1),
                                  _createElementVNode("td", _hoisted_113, _toDisplayString(_ctx.fmtQty2(p.out_qty)), 1),
                                  _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.money(p.in_value)), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[55] || (_cache[55] = _createElementVNode("h6", { class: "nd-subh" }, "By date", -1)),
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("table", _hoisted_116, [
                            _cache[54] || (_cache[54] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "Date"),
                                _createElementVNode("th", { class: "nd-amt" }, "In"),
                                _createElementVNode("th", { class: "nd-amt" }, "Out"),
                                _createElementVNode("th", { class: "nd-amt" }, "In ₨")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invDetail.by_date, (r) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: r.date
                                }, [
                                  _createElementVNode("td", null, _toDisplayString(_ctx.shortDate(r.date)), 1),
                                  _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.fmtQty2(r.in_qty)), 1),
                                  _createElementVNode("td", _hoisted_118, _toDisplayString(_ctx.fmtQty2(r.out_qty)), 1),
                                  _createElementVNode("td", _hoisted_119, _toDisplayString(_ctx.money(r.in_value)), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}